// extracted by mini-css-extract-plugin
module.exports = {"attribution":"quote_attribution__1hLqH","quote":"quote_quote__bbBX_","element":"quote_element__220xY"};